import { Logout } from "./Logout";
import { Logo } from "./Logo";

const HeaderDesktop = () => {
    return (
        <>
            <Logo />
            <Logout />
        </>
    );
};

export default HeaderDesktop;
